import React, { Suspense } from 'react';
import { Switch } from 'react-router-dom';

import { ContentRoute, LayoutSplashScreen } from '../../../_metronic/layout';
import Overview from './pages/PlanPage';

const Feed = () => {
	return (
		<Suspense fallback={<LayoutSplashScreen />}>
			<Switch>
				<ContentRoute path='/plans' component={Overview} />
			</Switch>
		</Suspense>
	);
};
export default Feed;
